/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { map } from 'rxjs';

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Inject,
  OnInit,
  Output,
  Renderer2,
  DOCUMENT
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthFacade } from '@ellf/app-auth';
import { RouterService } from '@ellf/app-routing';
import { RoleCodeEnum } from '@ellf/common-utils';
import { MENU } from './menu';
import { MenuItem } from './menu.model';

@Component({
  selector: 'ellf-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavbarComponent implements OnInit {
  menuItems: MenuItem[] = [];

  loggedUser$ = this.authFacade.selectLoggedUser$;

  isSupplier$ = this.loggedUser$.pipe(
    map((l) => l?.role?.code === RoleCodeEnum.Fornitore),
  );

  hideNavbar$ = this.activatedRoute.queryParams.pipe(
    map(
      (params) =>
        !!params[this.routerService.VIEW_MODE_PARAM] ||
        !!params[this.routerService.ADD_MODE_PARAM] ||
        !!params[this.routerService.FIND_MODE_PARAM] ||
        !!params[this.routerService.EDIT_MODE_PARAM],
    ),
  );

  @Output()
  logout: EventEmitter<void> = new EventEmitter();
  /**
   * Fixed header menu on scroll
   */
  @HostListener('window:scroll') getScrollHeight() {
    if (window.matchMedia('(min-width: 992px)').matches) {
      const header: HTMLElement = document.querySelector(
        '.horizontal-menu',
      ) as HTMLElement;
      if (window.pageYOffset >= 60) {
        header.parentElement!.classList.add('fixed-on-scroll');
      } else {
        header.parentElement!.classList.remove('fixed-on-scroll');
      }
    }
  }

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authFacade: AuthFacade,
    private routerService: RouterService,
  ) {}

  ngOnInit(): void {
    this.menuItems = MENU;

    /**
     * closing the header menu after route change in tablet/mobile devices
     */
    if (window.matchMedia('(max-width: 991px)').matches) {
      this.router.events.forEach((event) => {
        if (event instanceof NavigationEnd) {
          this.toggleHeaderMenu();
        }
      });
    }
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subMenus !== undefined ? item.subMenus.length > 0 : false;
  }

  collectSubMenuPermissions(item: MenuItem) {
    const permissions: string[] = [];
    item.subMenus?.forEach((sm) => {
      if (sm.subMenuItems) {
        sm.subMenuItems.forEach((smi) => {
          if (smi.permissions) {
            permissions.push(...smi.permissions);
          }
        });
      }
    });
    return permissions;
  }

  /**
   * Logout
   */
  onLogout(e: Event) {
    // e.preventDefault();
    // localStorage.removeItem('isLoggedin');

    // if (!localStorage.getItem('isLoggedin')) {
    //   this.router.navigate(['login']);
    // }
    // this.logout.emit();

    this.authFacade.logout();
  }

  onRefresh() {
    this.authFacade.forceRefresh();
  }

  /**
   * Toggle header menu in tablet/mobile devices
   */
  toggleHeaderMenu() {
    document
      .querySelector('.horizontal-menu .bottom-navbar')!
      .classList.toggle('header-toggled');
  }

  closeMenu() {
    // chiudi il menù dopo il tap
  }
}
